<template>
  <v-container fluid grid-list-md>
    <v-flex md12 sd12>
      <v-layout v-if="formload" row wrap>
        <v-flex text-md-center>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>

      <v-flex v-else v-for="(consumer, index) in getMyConsumers" :key="index" sm12 md12>
        <v-layout row wrap>
          <v-snackbar :timeout="6000" :top="true" color="#515151" v-model="token_copy">
            {{ 'consumer.token_copy' | t }}
            <v-btn color="white" flat @click="token_copy = false"> {{ 'consumer.close' | t }}</v-btn>
          </v-snackbar>
          <v-snackbar :timeout="6000" :top="true" color="#515151" v-model="upgrade">
            {{ 'consumer.upgrade' | t }}
            <v-btn color="white" flat @click="upgrade = false"> {{ 'consumer.close' | t }}</v-btn>
          </v-snackbar>

          <!-- DIGITAL -->
          <v-flex v-if="consumer.api === 'digital'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_digital' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- LAW -->
          <v-flex v-if="consumer.api === 'law'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_law' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- NEWS PRO -->
          <v-flex v-if="consumer.api === 'newspro'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_newspro' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- YOUTUBE -->
          <v-flex v-if="consumer.api === 'youtube'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_youtube' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- INSTAGRAM -->
          <v-flex v-if="consumer.api === 'instagram'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_instagram' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- FACEBOOK -->
          <v-flex v-if="consumer.api === 'facebook'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_facebook' | t }}</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>
          <!-- TWITTER -->
          <v-flex v-if="consumer.api === 'twitter'" sm2 md2>
            <span>
              <v-chip label color="white" :text-color="getColor[consumer.api]">
                <span class="titol_api_nom"
                  ><b>{{ 'consumer.title_twitter' | t }} X</b></span
                >
              </v-chip>
            </span>
            <br />
          </v-flex>

          <!-- DIGITAL -->
          <v-flex sm9 md7 v-if="consumer.api === 'digital'">
            <span class="title tw-txt-color-primary">
              <b>{{ consumer.counter | formatnumber }}</b>
              {{ 'consumer.request' | t }}
            </span>
            <span class="title tw-txt-color-primary right hidden-sm-and-down">{{ consumer.counter_limit | formatnumber }}</span>
            <v-progress-linear :value="calcPercent(consumer.api)" :color="getColor[consumer.api]" style="height: 7px; margin-top: 0px; margin-bottom: 4px"></v-progress-linear>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- LAW -->
          <v-flex sm9 md7 v-if="consumer.api === 'law'">
            <span class="title tw-txt-color-primary">
              <b>{{ consumer.counter | formatnumber }}</b>
              {{ 'consumer.request' | t }}
            </span>
            <span class="title tw-txt-color-primary right hidden-sm-and-down">{{ consumer.counter_limit | formatnumber }}</span>
            <v-progress-linear :value="calcPercent(consumer.api)" :color="getColor[consumer.api]" style="height: 7px; margin-top: 0px; margin-bottom: 4px"></v-progress-linear>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- NEWS PRO-->
          <v-flex sm9 md7 v-if="consumer.api === 'newspro'">
            <span class="title tw-txt-color-primary">{{ 'consumer.workers' | t }}</span>
            <br />
            <span>
              <consumer-workers :counter="consumer.counter" :counter_limit="consumer.counter_limit" :w_type="consumer.api" />
            </span>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- YOUTUBE -->
          <v-flex sm9 md7 v-if="consumer.api === 'youtube'">
            <span class="title tw-txt-color-primary">
              <b>{{ consumer.counter | formatnumber }}</b>
              {{ 'consumer.request' | t }}
            </span>
            <span class="title tw-txt-color-primary right hidden-sm-and-down">{{ consumer.counter_limit | formatnumber }}</span>
            <v-progress-linear :value="calcPercent(consumer.api)" :color="getColor[consumer.api]" style="height: 7px; margin-top: 0px; margin-bottom: 4px"></v-progress-linear>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- INSTAGRAM -->
          <v-flex sm9 md7 v-if="consumer.api === 'instagram'">
            <span class="title tw-txt-color-primary">{{ 'consumer.workers' | t }}</span>
            <br />
            <span>
              <consumer-workers :counter="consumer.counter" :counter_limit="consumer.counter_limit" :w_type="consumer.api" />
            </span>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- FACEBOOK -->
          <v-flex sm9 md7 v-if="consumer.api === 'facebook'">
            <span class="title tw-txt-color-primary">{{ 'consumer.workers' | t }}</span>
            <br />
            <span>
              <consumer-workers :counter="consumer.counter" :counter_limit="consumer.counter_limit" :w_type="consumer.api" />
            </span>
            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- TWITTER -->
          <v-flex sm9 md7 v-if="consumer.api === 'twitter'">
            <span class="title tw-txt-color-primary">{{ 'consumer.workers' | t }}</span>
            <br />
            <span>
              <consumer-workers :counter="consumer.counter" :counter_limit="consumer.counter_limit" :w_type="consumer.api" />
            </span>

            <span class="ml-3 tw-txt-color-primary hidden-sm-and-down">
              <b>{{ consumer.product_set_name }}:</b>
              <span class="ml-1">{{ consumer.product_name }}</span>
            </span>
            <span class="ml-3 right tw-txt-color-primary text-md-right hidden-sm-and-down">
              <b>{{ 'consumer.nextmonth' | t }}</b>
              <span class="ml-1">{{ consumer.renovation | date }}</span>
            </span>
          </v-flex>

          <!-- Copy key -->
          <v-flex sm1 md1>
            <span class="ml-5 mt-15 text-md-right hidden-sm-and-down">
              <v-btn dark :color="getColor[consumer.api]" v-clipboard:copy="consumer.token" @click.native="copy_token()"> <v-icon>content_copy</v-icon> {{ 'consumer.token' | t }} </v-btn>
            </span>
          </v-flex>
          <v-flex sm1 md1>
            <span class="ml-5 mt-15 text-md-right hidden-sm-and-down">
              <v-btn dark :color="getColor[consumer.api]" @click.native="upsellingmailupdate(consumer.api)"> <v-icon>file_upload</v-icon> {{ 'consumer.upselling' | t }} </v-btn>
            </span>
          </v-flex>
          <v-flex sm1 md1>
            <span class="hidden-md-and-up">
              <b>{{ 'consumer.token' | t }}:</b>
              <br />{{ consumer.token }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>&nbsp;</v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <faqs></faqs>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ConsumerWorkers from '@/components/ConsumerWorkers'
import Faqs from '@/components/Faqs'

export default {
  props: ['user'],
  components: {
    ConsumerWorkers,
    Faqs
  },
  computed: {
    ...mapGetters(['getTokenHeader', 'getServer', 'getConsumer', 'getMyConsumers', 'getUserId', 'getColor', 'getColorLow'])
  },
  methods: {
    ...mapActions(['setMyConsumers', 'rmKey']),
    calcPercent(api) {
      const actualper = 100 - (this.getConsumer(api).counter * 100) / this.getConsumer(api).counter_limit
      return 100 - actualper
    },
    copy_token() {
      this.token_copy = true
    },
    upsellingmailupdate(type) {
      const server = this.getServer
      const lang = this.$i18n.locale
      this.$http.get(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailupdate`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailupdate`)
        this.upgrade = true
      })
      this.$http.get(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailclient`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailclient`)
      })
    }
  },
  data: () => ({
    formload: true,
    token_copy: false,
    upgrade: false
  }),
  created() {
    const userid = this.user ? parseInt(this.user, 0) : this.getUserId

    this.$http
      .get(`${this.getServer}/users/${userid}/consumers`, this.getTokenHeader)
      .then(data => {
        if (data.data) {
          this.setMyConsumers(data.data)
          this.formload = false
        }
      })
      .catch(() => {
        this.rmKey()
      })
  }
}
</script>
<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.titol_api {
  font-size: 20px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.titol_api_nom {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}

.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
